//@ts-check

class RegisterService {
    constructor($http, Utility, $timeout, $rootScope, LocalStorageService, InternalLinksService) {
        this.$http = $http;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;

        this.init();
    }

    init() {
        
        this.buildings = {};
        this.userAlreadyExists = false;
        this.isUserConfirmed = true;
        this.registrationData = {
            isMobileRegistered: false,
            isWebRegistered: false,
            user: {}
        };

        /*
            this.mobileAppInfo = [
                {
                    platform: 'android',
                    details: {
                        thumbnailSrc: '',
                        storeUrl: 'https://play.google.com/store/apps/details?id=com.gloportal.pretor'
                    }
                },
                {
                    platform: 'ios',
                    details: {
                        thumbnailSrc: '',
                        storeUrl: 'https://play.google.com/store/apps/details?id=com.gloportal.pretor'
                    }
                }
            ];
            */
    }

    async checkIfUserExists(email) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }
            
            let url = await this.InternalLinksService.getLink('GetStateOfUser');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true);
                url = await this.InternalLinksService.getLink('GetStateOfUser');
            }

            url = `${url}?email=${email}`;

            const results = await this.$http.get(url);
            const { Data: data, WasSuccessful: wasSuccessful } = results.data;

            if (!wasSuccessful) {
                throw new Error('Error while validating the email.');
            }

            if (data === 0) {
                //NewUser
                this.userAlreadyExists = false;
                this.isUserConfirmed = false;
            } else if (data === 1) {
                // AuthTokenUser
                this.userAlreadyExists = false;
                this.isUserConfirmed = false;
            } else if (data === 3) {
                // NotConfirmedRegisteredUser
                this.userAlreadyExists = true;
                this.isUserConfirmed = false;
            } else if (data === 2) {
                // ConfirmedRegisteredUser
                this.userAlreadyExists = true;
                this.isUserConfirmed = true;
            }

            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            console.error(err);
            this.userAlreadyExists = false;
            const msg = `Error while checking whether the user already exists...`;
            this.$timeout(() => promiseHandler.reject(msg, err));
        }
        return promise;
    }

    async confirmEmail(email, token) {
        let promise, promiseHandler;
        
        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }

            if (!token) {
                throw new Error('Token must be supplied.');
            }
            this.InternalLinksService.getLinks('links', true);
            let url = await this.InternalLinksService.getLink('ConfirmEmail');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true);
                url = await this.InternalLinksService.getLink('ConfirmEmail');
            }
            url += `?email=${email}&token=${token}`;
            
            const results = await this.$http.post(url);
            
            if (results.data && results.data.hasOwnProperty('WasSuccessful') && results.data.WasSuccessful) {
                //debugger;
                this.registrationData.isWebRegistered = true;
                this.$timeout(() => promiseHandler.resolve());
            } else {
                //debugger;
                this.isWebRegistered = false;
                this.registrationData.user = {};
                throw new Error(`Could not confirm email: ${email}`);
            }
        } catch (err) {
            //debugger;
            const msg = `Error while confirming user registration`;
            console.error(msg), err;
            this.isWebRegistered = false;
            this.registrationData.user = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async registerUser(email, name, surname, cellphone, password) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }
            if (!name) {
                throw new Error('Name must be supplied.');
            }
            if (!surname) {
                throw new Error('Surname must be supplied.');
            }
            if (!cellphone) {
                throw new Error('Cellphone number must be supplied.');
            }
            if (!password) {
                throw new Error('Password must be supplied.');
            }

            let url = this.InternalLinksService.getLink('RegisterUser');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true);
                url = await this.InternalLinksService.getLink('RegisterUser');
            }

            const payload = {
                UserName: email,
                FirstName: name,
                LastName: surname,
                Password: password,
                CellPhoneNumber: cellphone,
                BusinessPartnerUnits: this.buildings
            };

            const results = await this.$http.post(url, payload);
            if (results.data.WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve(results.data));
            } else {
                throw new Error(`Error while registering user`);
            }
        } catch (err) {
            const msg = `Error while registering user`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getMobileAppInfo() {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });
            const url = 'https://play.google.com/store/apps/details?id=com.gloportal.pretor';

            const results = await this.$http.get(url);
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(`Error while getting the Pretor Mobile App information...`));
        }

        return promise;
    }

    async validateEmail(email) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }

            let url = await this.InternalLinksService.getLink('ValidateEmail');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true);
                url = await this.InternalLinksService.getLink('ValidateEmail');
            }

            url = `${url}?email=${email}`;

            const results = await this.$http.get(url, email);
            this.buildings = results.data;
            this.$timeout(() => promiseHandler.resolve(results.data));
        } catch (err) {
            const msg = `Error while validating email address`;
            console.error(msg), err;
            this.$timeout(() => promiseHandler.reject(msg));
        }

        return promise;
    }

    async registerMobile(email) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('RegisterMobileApp');

            if (!email) {
                throw new Error('Email address must be supplied...');
            }

            if (!url) {
                await this.InternalLinksService.getLinks('accounts/links', true, false, true);
                url = await this.InternalLinksService.getLink('RegisterMobileApp');
            }

            if (url.indexOf('{email}') > -1) {
                url = url.replace('{email}', email);
            } else {
                url = `${url}?email=${email}`;
            }

            var msg = 'Error while registering for the mobile application';
            const results = await this.$http.post(url);
            if (results.data.WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve());
            } else {
                throw new Error(msg);
            }
        } catch (err) {
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(msg));
        }

        return promise;
    }

    async forgotPassword(email) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = { reject, resolve };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }

            let url = await this.InternalLinksService.getLink('ForgotPassword');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true);
                url = await this.InternalLinksService.getLink('ForgotPassword');
            }

            const results = await this.$http.post(url, { UserName: email });
            if (results.data.WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve());
            } else {
                throw new Error('Error while sending password reset email');
            }
        } catch (err) {
            const msg = 'Error while sending password reset email';
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async resend(email) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!email) {
                throw new Error('Email must be supplied.');
            }

            let url = await this.InternalLinksService.getLink('ResendEmail');

            if (!url) {
                await this.InternalLinksService.getLinks('links', true, false, true);
                url = await this.InternalLinksService.getLink('ResendEmail');
            }

            url = `${url}/?email=${email}`;

            const results = await this.$http.post(url);
            if (results.data.WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve(true));
            } else {
                throw new Error(`Error while re-sending email`);
            }
        } catch (err) {
            const msg = `Error while re-sending email`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }
}

export default /* @ngInject */ ($http, Utility, $timeout, $rootScope, LocalStorageService, InternalLinksService) =>
    new RegisterService($http, Utility, $timeout, $rootScope, LocalStorageService, InternalLinksService);
